interface LinkItem {
    label: string;
    title?: string;
    href: string;
    openInNewWindow?: boolean;
    items: LinkItem[];
    [key: string]: unknown;
}

export function formatLink(item: LinkItem): LinkItem {
    const { openInNewWindow, ...rest } = item;

    return {
        ...rest,
        ...(!!openInNewWindow && { target: '_blank' }),
        ...(!!item?.items?.length && { items: item.items.map(formatLink) }),
    };
}
